import { VdoSession } from '@pcp/auth';

/**
 * Token goes in the fragment, never the query string: fragments are not sent to the server, so the
 * token stays out of the simulator's access logs and the `Referer` header.
 *
 * `simulatorBaseUrl` arrives straight from the `/api/auth/vdo` response body and is never parsed on
 * the way in, so it is validated here: `EmmIframeComponent` passes the result to
 * `bypassSecurityTrustResourceUrl`, which switches Angular's URL sanitising off. An empty value would
 * otherwise produce the relative `/#token=...` - the app embedding itself, with a live token in its
 * own fragment.
 *
 * Returns `null` for anything that is not an absolute https URL, or for an empty token; the caller
 * renders the unavailable state rather than an iframe.
 */
export const buildVdoSimulatorUrl = (session: VdoSession): null | string => {
    const base = parseHttpsUrl(session.simulatorBaseUrl);
    if (base === null || session.token === '') {
        return null;
    }

    // Assigning `hash` rather than concatenating keeps an existing query string intact.
    base.hash = `token=${session.token}`;
    return base.toString();
};

const parseHttpsUrl = (value: string): null | URL => {
    try {
        const url = new URL(value);
        return url.protocol === 'https:' ? url : null;
    } catch {
        return null;
    }
};
